module.exports = __webpack_public_path__ + "media/images/responsive/costumes/category_icons/dress/mini-063a73a3a74530cee45e2a947333ecef.jpg";